import Chart from 'chart.js/auto';

const tvToggleCheckbox = document.getElementById('toggle-football')

function getChartData() {
  return chartData.length ? chartData : [chartData];
}

const ctx = document.getElementById('myChart');
const body = document.body;

const datasets = getChartData();

const hideSecondDataset = body.classList.contains('hide-football');

const second = datasets.length > 1 ? datasets[datasets.length-1] : null;

if (hideSecondDataset) {
  datasets.pop();
}

if (ctx.dataset.ySuffix) {
  datasets.forEach(dataset => {
    dataset.tooltip = {
      callbacks: {
        label: (context) => `${context.dataset.label }: ${context.parsed.y}${ctx.dataset.ySuffix}`
      }
    };
  });
}

const chart = new Chart(ctx, {
  type: 'bar',
  data: { datasets },
  options: {
    scales: {
      y: {
        max: Number(ctx.dataset.maxY || 14),
        min: 0,
        stacked: true,
        title: {
          text: ctx.dataset.yLabel || 'Hours',
          display: true
        }
      },
      x: {
        stacked: true,
        title: {
          text: ctx.dataset.xLabel || 'Week of the year',
          display: true
        }
      },
    },
    plugins: {
      legend: {
        display: !ctx.dataset.hideLegend
      }
    }
  }
});

if (tvToggleCheckbox) {
  window.onpopstate = (_) => {
    if (document.location.hash == '#football') {
      tvToggleCheckbox.checked = true;
      showFootball();
    } else {
      tvToggleCheckbox.checked = false;
      hideFootball();
    }
  }

  function showFootball() {
    body.classList.remove('hide-football');
    tvNavLinks.forEach(link => {
      link.href = `${link.href}#football`;
    });
    chart.data.datasets.push(second);
    chart.update();
  }

  function hideFootball() {
    body.classList.add('hide-football');
    tvNavLinks.forEach(link => {
      link.href = link.href.replace('#football', '');
    });
    chart.data.datasets.pop();
    chart.update();
  }

  const tvNavLinks = document.querySelectorAll('.years-nav a');

  tvToggleCheckbox.addEventListener('change', e => {
    if (e.target.checked) {
      window.location.hash = '#football'
    } else {
      hideFootball();
      history.pushState('', document.title, window.location.pathname);
    }
  });

  tvToggleCheckbox.checked = !hideSecondDataset;
  tvNavLinks.forEach(link => {
    if (!hideSecondDataset) {
      link.href = `${link.href}#football`;
    }
  });
}
